export const PROFILE_BILLING = {
  REQUEST: "PROFILE_BILLING_REQUEST",
  SUCCESS: "PROFILE_BILLING_SUCCESS",
  FAILURE: "PROFILE_BILLING_FAILURE",
};
